const getToken = () => {
  const meta = document.querySelector('meta[name="api-token"]');
  return meta ? meta.content : null;
};

export { getToken };
